<template>
  <div class="login_container">
    <div class="pc">
      <div class="language">
      <el-popover placement="bottom" trigger="click" ref="popover">
        <div class="language-text-layout">
          <div class="language-text" @click="changeLanguage('zh')">{{ $t('account.name10') }}</div>
          <div class="language-text" @click="changeLanguage('en')">English</div>
        </div>
        <div slot="reference">{{ language }}<i class="el-icon-arrow-down"></i></div>
      </el-popover>
    </div>

    <div class="top-layout">
      <img src="@/assets/login/Frame 219.png" />
      <div>Listek IOT Platform</div>
    </div>
    <img class="img" src="@/assets/login/img1.png" />
    <div class="login_box">
      <div class="login">
        <div class="login_name">
          <div>{{ title }}</div>
        </div>
        <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form">
          <!-- 用户名-->
          <el-form-item prop="account">
            <el-input v-model="loginForm.account" prefix-icon="el-icon-user" :placeholder="$t('login.name2')"></el-input>
          </el-form-item>
          <!-- 密码-->
          <el-form-item prop="pwd">
            <el-input v-model="loginForm.pwd" type="password" prefix-icon="el-icon-lock" :placeholder="$t('login.name3')" show-password></el-input>
          </el-form-item>

          <div class="code-layout">
            <el-form-item prop="code">
              <el-input v-model="loginForm.code" type="text" prefix-icon="custom-icon" :placeholder="$t('login.name4')" class="code-input"></el-input>
            </el-form-item>
            <div class="code">{{ code }}</div>
            <i class="el-icon-refresh" @click="getCode"></i>
          </div>
        </el-form>
        <div class="checked-forget">
          <div>
            <el-checkbox v-model="checked">{{ $t('login.name5') }}</el-checkbox>
          </div>
          <div class="text-style" @click="goRetrievePassword">{{ $t('login.name6') }}</div>
        </div>

        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="login">{{ $t('login.name7') }}</el-button>
        <div class="btns text-style" @click="showYS">{{ $t('login.name8') }}</div>
        <!-- <el-collapse-transition>
        <div v-show="isShowYS">
          <div @click="autoInputAccount(1)" class="margin-top15" :class="loginType === 1 ? 'select-account' : ''">整车厂商演示账号登录</div>
          <div @click="autoInputAccount(2)" class="margin-top15" :class="loginType === 2 ? 'select-account' : ''">共享业务演示账号登录</div>
          <div @click="autoInputAccount(3)" class="margin-top15" :class="loginType === 3 ? 'select-account' : ''">品牌商户演示账号登录</div>
        </div>
      </el-collapse-transition> -->
      </div>
    </div>
    <div class="copyright">
      <div>{{ $t('login.name11') }}</div>
      <a class="beian" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">{{ $t('screen.name4') }}</a>
    </div>
    </div>
    <div class="mb">
      <div class="mb-content">
        <div class="title">{{ $t('account.name29') }}</div>
      <div class="top-layout">
        <img src="@/assets/Frame 219.png" />
        <div>Listek IOT Platform</div>
      </div>
      <div class="text1">{{ $t('account.name30') }}</div>
      <div class="account-password">
      <div class="account"> <el-input @input="input" v-model="loginForm1.account" prefix-icon="el-icon-user" :placeholder="$t('account.name31')"></el-input></div>
      <div class="password"> <el-input @input="input" v-model="loginForm1.pwd" type="password" prefix-icon="el-icon-lock" :placeholder="$t('login.name3')" show-password></el-input></div>
      </div>
      <el-button  class="login-bt"  type="primary"  :disabled="disabled" :loading="loading" @click="getLogin">{{ $t('login.name7') }}</el-button>
      <div class="forget-password">
        <div class="text" @click="jumpRegisterAccount">{{ $t('account.name32') }}</div>
        <div class="text" @click="jumpForgetPassWord">{{ $t('login.name6') }}</div>
      </div>
      </div>
      <div class="language-text-layout">
          <div class="language-text">{{ language }}</div>
            <div class="qiehuan" @click="showLanguagePicker">{{ $t('account.name33') }}</div>
        </div>
    </div>
    <el-dialog
  :title="$t('login.name13')"
  v-if="dialogVisible"
  :visible.sync="dialogVisible"
  width="60%"
  :before-close="handleClose">
  <div class="ys-table">
    <div class="title">
     <div class="row1">
      {{ $t('login.name14') }}
     </div>
     <div class="row2">
      {{ $t('login.name15') }}
     </div>
     <div class="row3">
      {{ $t('login.name16') }}
     </div>
     <div class="row4">
      {{ $t('login.name17') }}
     </div>
     <div class="row5">
      {{ $t('login.name18') }}
     </div>
    </div>
    <div class="content" v-for="(item, index) in tableList" :key="index">
     <div class="row1">
      {{ item.accountName }}
     </div>
     <div class="row2">
      {{ item.websiteUrl }}
     </div>
     <div class="row3">
      {{ item.loginName }}
     </div>
     <div class="row4">
      {{ item.loginPwd }}
     </div>
     <div class="row5">
      <el-button type="text" size="small" @click="goNewLogin(item)"> {{ $t('login.name19') }}</el-button>
     </div>
    </div>
  </div>
  <!-- <el-table class="ys-table" :data="tableList" :header-cell-style="{ fontSize: '14px', background: 'rgba(245, 248, 255)', color: '#333' }" v-loading="tableLoading">
      <el-table-column label="账号名称" prop="accountName"  width="200"> </el-table-column>
      <el-table-column label="演示网站" prop="websiteUrl" > </el-table-column>
      <el-table-column label="账号" prop="loginName" > </el-table-column>
      <el-table-column label="密码" prop="loginPwd"> </el-table-column>
      <el-table-column label="一键登录">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="goNewLogin(scope.row)">立即登录</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <div class="ys2">
        <div class="item-ys2" v-for="(item, index) in ysList2" :key="index">
         <div class="item-img">
          <img :src="item.imgPath" />
         </div>
         <div class="item-text">
          <div class="item-text1">{{ item.accountName }}</div>
          <div>{{ $t('login.name20') }}{{ item.loginName }}</div>
          <div>{{ $t('login.name21') }}{{ item.loginPwd }}</div>
         </div>
        </div>
    </div>
</el-dialog>
<el-drawer
  :visible.sync="drawer"
   direction="btt"
  :with-header="false">
  <div class="drawer-title">
    <div class="titles">{{ $t('account.name6') }}</div>
    <div class="quxiao" @click="drawer=false">{{ $t('account.name9') }}</div>
  </div>
  <div class="drawer-content">
 <div :class="language === $t('account.name10') ? 'item-languages':'item-language'"  @click="changeLanguage('zh')">{{ $t('account.name10') }}</div>
  <div :class="language === 'English' ? 'item-languages':'item-language'"  @click="changeLanguage('en')">{{ $t('account.name11') }}</div>
  </div>
</el-drawer>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { encrypt } from '@/utils/utils.js'
import { getImgCode, getMenus, queryDemoAccountList } from '@/api/user.js'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      dialogVisible: false,
      drawer: false,
      tableList: [],
      ysList2: [],
      tableLoading: false,
      disabled: true,
      loginType: 0,
      loginForm1: {
        account: '',
        pwd: ''
      },
      loginForm: {
        account: '',
        key: '',
        code: '',
        pwd: ''
      },
      code: '',
      key: '',
      // 这是表单验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        account: [
          {
            required: true,
            message: this.$t('register.name4'),
            trigger: 'blur'
          }
        ],

        code: [
          {
            required: true,
            message: this.$t('login.name4'),
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        pwd: [
          {
            required: true,
            message: this.$t('login.name3'),
            trigger: 'blur'
          }
          // {
          //   min: 6,
          //   max: 15,
          //   message: '长度在 6 到 15 个字符',
          //   trigger: 'blur'
          // }
        ]
      },
      isShowYS: false,
      loading: false,
      checked: false,
      title: this.$t('login.name1'),
      language: this.$t('account.name10'),
      menuList: [],
      buttonPerms: '',
      menuPerms: ''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  created() {
    // console.log(this.$route.query)
    Cookies.remove('vue_admin_token')
    localStorage.setItem('buttonPerms', '')
    localStorage.setItem('permName', '')
    localStorage.setItem('clickIndex', 0)
    if (localStorage.getItem('lang') === 'en') {
      this.language = 'English'
    } else {
      this.language = this.$t('account.name10')
    }
    if (this.$route.query.type === '2') {
      // this.isShowYS = true
      this.title = this.$t('login.name12')
    }
    this.getCode()
  },
  mounted() {
    // if (typeof window.__wxjs_environment !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
    //   console.log('当前是在微信小程序内嵌 H5 页面')
    // } else {
    //   console.log('当前是在浏览器中，非小程序内嵌')
    // }
    var account = ''
    var pwd = ''
    if (window.location.href.indexOf('&pwd=') > -1) {
      this.loginForm.account = ''
      this.loginForm.pwd = ''
      const paramData1 = window.location.href.split('&')
      var paramData2 = []
      paramData1.map((item) => {
        paramData2.push(item.split('='))
      })
      if (paramData2) {
        account = decodeURIComponent(paramData2[0][1])
        pwd = decodeURIComponent(paramData2[1][1])
      }
    }
    // console.log('account====', paramData1)
    if (account && pwd) {
      this.loginForm.account = account
      this.loginForm.pwd = pwd
      getImgCode().then(res => {
        this.code = encrypt(res.data.code)
        this.key = res.data.key
        this.loginForm.code = this.code
        this.login()
      })
    } else {
      this.loginForm.account = localStorage.getItem('account') || ''
      this.loginForm.pwd = localStorage.getItem('password') || ''
    }
  },
  methods: {
    goNewLogin(row) {
      var url = row.websiteUrl + '?account=' + row.loginName + '&pwd=' + row.loginPwd
      window.open(url)
    },
    handleClose() {
      this.dialogVisible = false
    },
    getCode() {
      getImgCode().then(res => {
        this.code = encrypt(res.data.code)
        this.key = res.data.key
      })
    },
    autoInputAccount(type) {
      this.loginType = type
      if (type === 1) {
        this.loginForm.account = 'changshang@189.cn'
        this.loginForm.pwd = 'Cs@12345678'
      } else if (type === 2) {
        this.loginForm.account = 'shanghugongxiang@189.cn'
        this.loginForm.pwd = 'Shgx@12345678'
      } else if (type === 3) {
        this.loginForm.account = 'shanghushouche@189.cn'
        this.loginForm.pwd = 'Shsc@12345678'
      }
      getImgCode().then(res => {
        this.code = encrypt(res.data.code)
        this.key = res.data.key
        this.loginForm.code = this.code
        this.login()
      })
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      if (this.isShowYS) {
        this.title = this.$t('login.name12')
      } else {
        this.title = this.$t('login.name1')
      }
      if (lang === 'zh') {
        this.language = this.$t('account.name10')
      } else {
        this.language = 'English'
      }
      this.$refs.popover.doClose()
      this.drawer = false
    },
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    showYS() {
      this.dialogVisible = true
      this.tableLoading = true
      queryDemoAccountList().then(res => {
        this.tableList = res.data.list1
        this.ysList2 = res.data.list2
        this.tableLoading = false
      })
      // if (this.isShowYS) {
      //   this.title = this.$t('login.name12')
      // } else {
      //   this.title = this.$t('login.name1')
      // }
      // window.open(window.location.origin + '/#/register')
    },
    goRegister() {
      this.$router.push('/register')
    },
    goRetrievePassword() {
      this.$router.push('/retrievePassword')
    },
    jumpForgetPassWord() {
      this.$router.push('/forgetPassword')
    },
    jumpRegisterAccount() {
      this.$router.push('/registerAccount')
    },
    input() {
      if (this.loginForm1.account && this.loginForm1.pwd) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      console.log('====', this.disabled)
    },
    getLogin() {
      this.loading = true
      this.$store
        .dispatch('user/phoneLogin', this.loginForm1)
        .then(() => {
          this.$store.dispatch('user/getInfo').then(() => {
            getMenus()
              .then((res) => {
                if (res.code === 200) {
                  if (res.data.menus) {
                    this.menuList = res.data.menus[0].childList
                  }
                  const buttonPermsList = []
                  res.data.button.map((item) => {
                    buttonPermsList.push(item.perms)
                  })
                  this.buttonPerms = buttonPermsList.join(',')
                  localStorage.setItem('buttonPerms', this.buttonPerms)
                  const menuPermsList = []
                  this.menuList.map((item) => {
                    menuPermsList.push(item.menuId + '')
                  })
                  this.menuPerms = menuPermsList.join(',')
                  localStorage.setItem('menuPerms', this.menuPerms)
                  if (this.menuPerms.indexOf('2182') > -1) {
                    this.$router.replace({ path: '/home', query: { tab: '1', title: this.$t('tabmenu.name69') } })
                  } else if (this.menuPerms.indexOf('2183') > -1) {
                    this.$router.replace({ path: '/home', query: { tab: '2', title: this.$t('tabmenu.name68') } })
                  } else if (this.menuPerms.indexOf('2184') > -1) {
                    this.$router.replace({ path: '/home', query: { tab: '3', title: this.$t('account.name12') } })
                  }
                }
              })
              .catch(() => {})
          })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    showLanguagePicker() {
      this.drawer = true
    },
    onChangePicker() {},
    login() {
      this.$refs.loginFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          this.loginForm.key = this.key
          this.$store
            .dispatch('user/login', this.loginForm)
            .then(() => {
              if (this.checked) {
                localStorage.setItem('account', this.loginForm.account)
                localStorage.setItem('password', this.loginForm.pwd)
              }
              this.$store.dispatch('user/getInfo').then(() => {
                if (this.userinfo.tenantType === 0 || this.userinfo.tenantType === 1) {
                  this.$router.push('/dataScreening')
                } else {
                  this.$router.push('/realTimeMonitoring')
                }
              })
              this.loading = false
            })
            .catch(() => {
              this.getCode()
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-popover {
  min-width: 70px;
}
.custom-icon {
  width: 16px;
  height: 16px;
  line-height: 16px;
  margin-left: 5px;
  background-image: url(~@/assets/login/Frame.png);
  background-size: cover;
  display: inline-block;
}
.account-password{
  .el-input__inner {
  height: 49px;
  line-height: 49px;
  border: 0px solid #DCDFE6;
}
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 1024px) {
  .mb{
    display: none;
  }
  .ys-table{
    display: flex;
    width: 100%;
    flex-direction: column;
    .title{
      width: 100%;
      display: flex;
      flex-direction: row;
      height: 39px;
      color: #333333;
  background:rgba(245, 248, 255);
  border: 1px solid #abc5ff;
  align-items: center;
      .row1{
        width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #abc5ff;
      height: 100%;
    }
    .row2{
      width: 30%;
      border-right: 1px solid #abc5ff;
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 7.5px;
      justify-content: center;
      padding-right: 7.5px;
    }
    .row3{
      width: 20%;
      padding-left: 7.5px;
      border-right: 1px solid #abc5ff;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 7.5px;
    }
    .row4{
      width: 20%;
      padding-left: 7.5px;
      border-right: 1px solid #abc5ff;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 7.5px;
    }
    .row5{
      width: 10%;
      padding-left: 7.5px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 7.5px;
    }
    }
    .content{
      width: 100%;
      display: flex;
      flex-direction: row;
      height: 40px;
      align-items: center;
      color: #333333;
      border-bottom: 1px solid #abc5ff;
      border-left: 1px solid #abc5ff;
      border-right: 1px solid #abc5ff;
      .row1{
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #abc5ff;
      height: 100%;
    }
    .row2{
      width: 30%;
      color: #007aff;
      border-right: 1px solid #abc5ff;
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 15px;
    }
    .row3{
      width: 20%;
      padding-left: 7.5px;
      padding-right: 7.5px;
      border-right: 1px solid #abc5ff;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .row4{
      width: 20%;
      padding-left: 7.5px;
      padding-right: 7.5px;
      border-right: 1px solid #abc5ff;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .row5{
      width: 10%;
      padding-left: 7.5px;
      padding-right: 7.5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    }
  }

  .ys2{
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 24px;
    .item-ys2{
      width: calc(50% - 14px);
      // padding: 10px;
      // margin-right: 10px;
      // margin-left: 20px;
      display: flex;
      flex-direction: row;
      border: 1px solid #abc5ff;
      .item-img{
        width: 100px;
        height: 100px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .item-text{
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        .item-text1{
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
  }
.login_container {
  background: #93defe;
  background-size: cover;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url(~@/assets/login/Maskgroup.jpg);
  background-size: 100% 100%;

  .margin-top15{
    width: 100%;
    text-align: center;
    margin-top: 15px;
    cursor: pointer;
  }
  .select-account{
    font-weight: 800;
  }
  .img {
    width: 45vw;
    height: 24.7vw;
    min-width: 604px;
    min-height: 331px;
    position: absolute;
    top: 50%;
    left: 96px;
    transform: translate(0%, -50%);
  }
}

.language {
  position: absolute;
  right: 60px;
  top: 30px;
  cursor: pointer;
  font-size: 14px;
  .el-icon-arrow-down {
    font-size: 18px;
    margin-left: 5px;
  }
}
.language-text-layout {
  display: flex;
  flex-direction: column;
  .language-text {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
  }

  .language-text:hover {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: #0f73e6;
  }
}
.code-layout {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
}
.text-style {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: #0f73e6;
  cursor: pointer;
}

.btns {
  width: 100%;
  text-align: center;
  margin-top: 34px;
}
.margin-top20 {
  margin-top: 20px;
}

.checked-forget {
  margin-top: -5px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.zsb-tyb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;
}

.icon-zsb {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    margin-left: 4px;
    font-size: 16px;
    line-height: 22.4px;
  }
}
.el-icon-refresh {
  margin-bottom: 22px;
  margin-left: 8px;
  cursor: pointer;
}
.code-input {
  width: 220px;
}
.code {
  background: #064d9d;
  width: 90px;
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
  font-size: 16px;
  margin-left: 8px;
  margin-bottom: 22px;
  text-align: center;
  color: #fff;
}

.login_box {
  width: 420px;
  height: 468px;
  position: absolute;
  top: 50%;
  right: 11.11vw;
  z-index: 10;
  transform: translate(0%, -50%);
}

.login_box .login_l_img {
  float: left;
  width: 432px;
  height: 440px;
  margin-left: 50px;
}

.login_box .login_l_img img {
  width: 500px;
  height: 440px;
}

.top-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  top: 30px;
  left: 60px;
  img {
    width: 48px;
    height: 48px;
  }
  div {
    font-family: PingFang SC;
    font-size: 24px;
    font-weight: 500;
    line-height: 33.6px;
    text-align: left;
    margin-left: 12px;
    color: #0c2358;
  }
}

.login {
  height: 100%;
  width: 100%;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 0px;
  box-sizing: border-box;
  float: right;
  margin-right: 0px;
  position: relative;
}

.login_logo {
  width: 120px;
  height: 120px;
  border: 5px solid #93defe;
  border-radius: 100px;
  background: #fff;
  text-align: center;
  line-height: 110px;
  position: absolute;
  top: -60px;
  right: 140px;
}

.login_name {
  width: 100%;
  text-align: center;
}

.login_name div {
  width: 100%;
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  line-height: 33.6px;
  font-weight: 500;
  color: #444;
  font-family: PingFang SC;
}

.login_logo img {
  width: 100px;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
}

.copyright {
  font-size: 14px;
  color: #515357;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50% , 0);
  bottom: 30px;
  z-index: 9;
  display: flex;
  flex-direction: row;
  .beian{
    color: #007aff;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 10px;
  }
}
}
@media screen and (max-width: 1023px) {
  .pc{
    display: none;
  }
  .mb{
    width: 100%;
    display: flex;
    position: fixed;
    flex-direction: column;
    height: 100vh;
    background: #fff;
    background-image: url(../../assets/login-bg.png);
    background-size: cover;
    overflow: hidden;
  }
  .mb-content{
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .language-text-layout{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 60px;
    .language-text{
      font-size: 15px;
    }
    .qiehuan{
      color: #007aff;
      font-size: 15px;
      margin-left: 4px;
    }
  }
  .drawer-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 25px;
    .item-languages{
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
      font-size: 15px;
      color: #555555;
    }
    .item-language{
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #555555;
    }
  }
  .drawer-title{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px;
    .titles{
      font-weight: 500;
      font-size: 16px;
      color: #555555;
    }
    .quxiao{
      font-size: 15px;
      color: #555555;
    }
  }
  .title{
    display: flex;
    width: 100%;
    justify-content: center;
    height: 54px;
    align-items: center;
    font-size: 16px;
    color: #171717;
    font-weight: 800;
  }
  .top-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  img {
    width: 60px;
    height: 60px;
  }
  div {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 33.6px;
    text-align: left;
    margin-top: 12px;
    color: #0c2358;
  }
}
.text1{
  font-size: 20px;
  color: #555555;
  font-weight: 500;
  margin-left: 15px;
  margin-top: 50px;
}
.account{
 padding: 0px 15px;
 margin-top: 30px;
}
.password{
  padding: 15px;
}
.login-bt{
  width: calc(100% - 30px);
  padding: 15px;
  margin: 15px;
  font-weight: 600;
}
.forget-password{
  width: 100%;
  display: flex;
  justify-content: space-between;
  .text{
    color: #555555;
    font-size: 15px;
    margin-left: 15px;
    margin-right: 15px;
    cursor: pointer;
  }
}
}
</style>
